import React, { useRef, useState, useEffect} from 'react';


import AdminOrderView from '../../views/AdminView/AdminOrderView';

import { useParams } from 'react-router-dom';
import { useOrderContext } from '../Context/OrderContext';

const AdminOrderComponent = () => {
    
    const didFetch = useRef(false); 
    const [branchData, setBranchDetails] = useState({});
    const { id } = useParams();
    const { orderData, OrderDetails } = useOrderContext(); // Use your context function
    
    const fetchData = async () => {
        try {
            
            if (id) {
                const branch = await OrderDetails(id);
                setBranchDetails(branch);
             
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
        fetchData();

            didFetch.current = true;
        }
    });
    return <div>
   
        {didFetch && orderData && <AdminOrderView />}
    </div>
    // return <PartnerView Partnersdata={partners}/>
   
};

export default AdminOrderComponent;
